import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';
import './Picture.scss';

export default function Picture({ content }) {

    return (
        <div
            className="workshop-picture-container"
        >
            {
                content.AvecCadreEtOmbre ?
                    <div className="workshop__image-container">
                        <div className="workshop__image-wrapper">
                            <StrapiImageWithSkeleton
                                picture={content.Photo}
                                loading="eager"
                                size='large'
                                fetchpriority='high'
                                className="workshop-picture"
                            />
                        </div>
                        <div className="workshop__image-shadow"></div>
                    </div>
                    :
                    <StrapiImageWithSkeleton
                        picture={content.Photo}
                        loading="eager"
                        size='large'
                        fetchpriority='high'
                        className="workshop-picture"
                    />

            }
        </div>
    )
}